"use client";
import { InputGroup, Form } from "react-bootstrap";
import { BsSearch } from "react-icons/bs";
import { ChangeEvent } from "react";
import { Stack } from "react-bootstrap";
import { useState } from "react";
import moment from "moment";
import { useI18n } from "../../i18n";

type RecordSearchInputProps = {
  searchValue: string;
  setSearchValueFunc: (val: string) => void;
  startDate?: string;
  setStartDateFunc?: (val: string) => void;
  endDate?: string;
  setEndDateFunc?: (val: string) => void;
};

export default function RecordSearchInput({
  searchValue,
  setSearchValueFunc,
  startDate,
  setStartDateFunc,
  endDate,
  setEndDateFunc,
}: RecordSearchInputProps) {
  const { t } = useI18n();
  const [startDateInvalid, setStartDateInvalid] = useState(false);
  const [endDateInvalid, setEndDateInvalid] = useState(false);

  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (typeof setSearchValueFunc === "function") {
      setSearchValueFunc(event.target.value);
    }
  };

  const onStartDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (typeof setStartDateFunc === "function") {
      setStartDateFunc(event.target.value);
    }
    const invalid =
      (event.target.value.length > 0 && event.target.value.length < 6) ||
      (event.target.value.length > 0 && !moment(event.target.value).isValid());
    setStartDateInvalid(invalid);
  };

  const onEndDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (typeof setEndDateFunc === "function") {
      setEndDateFunc(event.target.value);
    }
    const invalid =
      (event.target.value.length > 0 && event.target.value.length < 6) ||
      (event.target.value.length > 0 && !moment(event.target.value).isValid());
    setEndDateInvalid(invalid);
  };

  return (
    <Stack gap={2}>
      <InputGroup style={{ maxWidth: "60.6%" }}>
        <InputGroup.Text>
          <BsSearch />
        </InputGroup.Text>
        <Form.Control
          value={searchValue}
          onChange={onSearchChange}
          aria-label="Search"
          placeholder={t("common.search")}
        />
      </InputGroup>
      <Stack gap={1} direction="horizontal">
        {typeof setStartDateFunc === "function" && (
          <InputGroup style={{ maxWidth: "30%" }}>
            <InputGroup.Text>S</InputGroup.Text>
            <Form.Control
              value={startDate}
              onChange={onStartDateChange}
              aria-label="Start Date"
              placeholder={t("fields.startDate")}
              isInvalid={startDateInvalid}
            />
          </InputGroup>
        )}
        {typeof setEndDateFunc === "function" && (
          <InputGroup style={{ maxWidth: "30%" }}>
            <InputGroup.Text>E</InputGroup.Text>
            <Form.Control
              value={endDate}
              onChange={onEndDateChange}
              aria-label="End Date"
              placeholder={t("fields.endDate")}
              isInvalid={endDateInvalid}
            />
          </InputGroup>
        )}
      </Stack>
    </Stack>
  );
}
